export default __webpack_public_path__ + "4f96757621e32517d59b17abcf6f4e60.jpg";